import * as React from 'react'
import className from 'classnames'
import { Link } from 'gatsby'
import * as style from './footer.module.scss'
import ButtonPrimary from '../../components/common/buttons/ButtonPrimary'
import useFooterQueryHook from '../../hooks/query/useFooterQueryHook'
import keyGenerator from '../../utils/keyGenerator'

const Footer = () => {
  const footerQueryData = useFooterQueryHook()
  const socials = [
    {
      img: '/icons/socials/instagram.svg',
      url: 'https://www.instagram.com/visartech/',
      title: 'instagram',
    },
    {
      img: '/icons/socials/fb.svg',
      url: 'https://www.facebook.com/visartech.studio/',
      title: 'facebook',
    },
    {
      img: '/icons/socials/linked.svg',
      url: 'https://www.linkedin.com/company/visartech',
      title: 'linkedIn',
    },
    {
      img: '/icons/socials/tw.svg',
      url: 'https://twitter.com/VISARTECH',
      title: 'twitter',
    },
    {
      img: '/icons/socials/m.svg',
      url: 'https://visartech.medium.com/',
      title: 'medium',
    },
  ]

  const footerButtonData = {
    text: 'More Contacts',
    url: {
      uri: '/contacts/',
    },
    addQuery: null,
    query: null,
  }

  return (
    <footer className={style.footer}>
      <div className={className(style.container, 'container')}>
        <div className={style.data}>
          <p className={style.title}>Contacts</p>
          <div className={style.dataInfo}>
            <a
              href={`tel:${footerQueryData.wp.acfOptionsContacts.contacts.phone.description}`}
            >
              {footerQueryData.wp.acfOptionsContacts.contacts.phone.description}
            </a>
            <a
              href={`mailto:${footerQueryData.wp.acfOptionsContacts.contacts.email.description}`}
            >
              {footerQueryData.wp.acfOptionsContacts.contacts.email.description}
            </a>
            <p>
              {
                footerQueryData.wp.acfOptionsContacts.contacts.address
                  .description
              }
            </p>
          </div>
          <ButtonPrimary
            buttonData={footerButtonData}
            btnClass={style.button}
          />
        </div>

        <div className={style.links}>
          <p className={style.title}>Hot Links</p>
          <div className={style.linksData}>
            {footerQueryData.allWpHotLink.edges.map((elem, index) => (
              <a
                key={keyGenerator(index, elem.node.title)}
                className={style.linksItem}
                href={elem.node.hotLink.button.url.uri}
              >
                {elem.node.hotLink.button.text}
              </a>
            ))}
          </div>
          <div className={style.linksSocial}>
            {socials.map((elem, index) => (
              <a
                key={keyGenerator(index, elem.url)}
                rel="noopener noreferrer"
                target="_blank"
                className={style.linksSoc}
                href={elem.url}
              >
                <img
                  title={elem.title}
                  loading="lazy"
                  alt="Logotype"
                  src={elem.img}
                  width="45"
                  height="45"
                />
              </a>
            ))}
          </div>
        </div>

        <div className={style.terms}>
          <div className={style.termsLinks}>
            <Link to="/cookie-policy/">Cookie Policy</Link>
            <Link to="/privacy-policy/">Privacy Policy</Link>
          </div>
          <p className={style.termsRules}>
            © {new Date().getFullYear()} Visartech Inc. All rights reserved.
            Registered in the U.S. Trademark Office
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
